import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  posCarts: [],
  posCart: null,
};

const slice = createSlice({
  name: "posCart",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getCartsSuccess(state, action) {
      state.isLoading = false;
      state.posCarts = JSON.parse(JSON.stringify(action.payload));
    },

    reRenderCartsSuccess(state, action) {
      state.posCart.map((cg) => {
        if (cg.id === action.payload) {
          cg.selected = true;
        }
      });
    },

    getCartSuccess(state, action) {
      state.isLoading = false;
      state.posCart = JSON.parse(JSON.stringify(action.payload));
    },

    updatePosCart(state, action) {
      state.isLoading = false;
      state.posCart = {
        ...state.posCart,
        customer: action.payload.customer,
        cartType: action.payload.cartType,
        orderType: action.payload.cartType,
        deliveryFees: action.payload.deliveryFee,
        isDeliveryFeesApplicable: action.payload.includeDeliveryFee,
        rider: action.payload.selectedRider,
        isOrderEdit: action.payload.tempOrderEdit,
        subTotal: action.payload.subTotal,
        state: action.payload.state,
      };
    },

    // updatePosCart(state, action) {
    //   state.isLoading = false;

    //   const payload = action.payload || {};
    //   const currentCart = state.posCart || {};

    //   state.posCart = {
    //     ...currentCart,

    //     customer: payload.customer ?? currentCart.customer,
    //     cartType: payload.cartType ?? currentCart.cartType,
    //     orderType: payload.orderType ?? payload.cartType ?? currentCart.orderType,
    //     deliveryFees: payload.deliveryFees ?? payload.deliveryFee ?? currentCart.deliveryFees,
    //     isDeliveryFeesApplicable:payload.isDeliveryFeesApplicable ?? payload.includeDeliveryFee ?? currentCart.isDeliveryFeesApplicable,
    //     rider: payload.rider ?? payload.selectedRider ?? currentCart.rider,
    //     isOrderEdit: payload.tempOrderEdit ?? currentCart.isOrderEdit,
    //     subTotal: payload.subTotal ?? currentCart.subTotal,
    //     state: payload.state ?? currentCart.state,

    //     items: payload.items ?? currentCart.items,
    //     discount: payload.discount ?? currentCart.discount ?? 0,
    //     discountObject: payload.discountObject ?? currentCart.discountObject ?? {},
    //     discountOnItem: payload.discountOnItem ?? currentCart.discountOnItem ?? false,
    //     promotion: payload.promotion ?? currentCart.promotion ?? 0,
    //     promotionObj: payload.promotionObj ?? currentCart.promotionObj ?? {},
    //     promotionSnapshot:payload.promotionSnapshot ?? currentCart.promotionSnapshot ?? [],

    //     tax: payload.tax ?? currentCart.tax,
    //     taxObject: payload.taxObject ?? currentCart.taxObject,
    //     total: payload.total ?? currentCart.total,
    //     serviceFees: payload.serviceFees ?? currentCart.serviceFees,
    //     billNumber: payload.billNumber ?? currentCart.billNumber,
    //     cartId: payload.cartId ?? currentCart.cartId,
    //   };
    // },
    updatePosCartForStoreDelivery(state, action) {
      state.isLoading = false;
      state.posCart = {
        ...state.posCart,
        cartType: action.payload.cartType,
        rider: action.payload.selectedRider,
        isOrderEdit: action.payload.tempOrderEdit,
      };
    },
    updateReceiptCountOnCart(state, action) {
      state.isLoading = false;
      state.posCart = {
        ...state.posCart,
        receiptCount: action.payload.receiptCount,
      };
    },
    updateCartAfterDiscount(state, action) {
      state.isLoading = false;
      state.posCart = JSON.parse(JSON.stringify(action.payload));
    },
    clearState(state) {
      state.isLoading = false;
      state.error = null;
      state.posCarts = [];
      state.posCart = null;
    },
      updatePosCartTax(state, action) {
      state.isLoading = false;
      state.posCart = {
        ...state.posCart,
        tax: action.payload.tax,
        taxObject: action.payload.taxObject,
      };
    },

    updateClassicalCartOrderTypeLocal: (state, action) => {
      state.posCart = {
        ...state.posCart,
        orderType: action.payload?.orderType,
        cartType: action.payload?.cartType,
      };
    },

    updateClassicalCartFinanceLocal: (state, action) => {
      const payload = action.payload || {};

      state.posCart = {
        ...state.posCart,
        promotion: Number(payload.promotion ?? state.posCart?.promotion ?? 0),
        promotionObj: payload.promotionObj ?? state.posCart?.promotionObj ?? {},
        promotionSnapshot: Array.isArray(payload.promotionSnapshot) ? payload.promotionSnapshot : Array.isArray(state.posCart?.promotionSnapshot) ? state.posCart.promotionSnapshot : [],
        serviceFees: Number(payload.serviceFees ?? state.posCart?.serviceFees ?? 0),
      };
    },
    updateClassicalCartForSubmit: (state, action) => {
      state.posCart = action.payload;
    },

  },
});

export default slice.reducer;

export const { clearState, updatePosCart,updateClassicalCartOrderTypeLocal,updateClassicalCartForSubmit,updateClassicalCartFinanceLocal } = slice.actions;

export function reRenderCarts(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.reRenderCartsSuccess(id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCart(venueId, venueUserId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/posCart?venueId=${venueId}&venueUserId=${venueUserId}`
      );
      dispatch(slice.actions.getCartSuccess(response.data));
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      return false;
    }
  };
}

export function removeItemFromCart(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(
        `${backendUrl}/posCart/removeItem`,
        data
      );
      dispatch(slice.actions.getCartSuccess(response.data));
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addItemToCart(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(
        `${backendUrl}/posCart/addItem`,
        data
      );
      dispatch(slice.actions.getCartSuccess(response.data));
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function refreshCartPromotionsForOrderType(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.post(
        `${backendUrl}/posCart/refreshPromotions`,
        data
      );

      dispatch(slice.actions.getCartSuccess(response.data));

      return {
        data: response?.data,
        status: response.status,
      };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      return false;
    }
  };
}

export function deleteCartById(cartId, token, user) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(
        `${backendUrl}/posCart/deleteCartById/${cartId}?deletedById=${user.id}&deletedBy=${"venueUser"}&isSuperAdmin=${user.isSuperAdmin}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(slice.actions.clearState());
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function updatePosCartWithCustomer(
  customer,
  cartType,
  deliveryFee,
  includeDeliveryFee,
  selectedRider,
  tempOrderEdit,
  subTotal,
  state,
) {
  return (dispatch) => {
    dispatch(
      slice.actions.updatePosCart({
        customer,
        cartType,
        deliveryFee,
        includeDeliveryFee,
        selectedRider,
        tempOrderEdit,
        subTotal,
        state
      })
    );
  };
}
export function updatePosCartWithCustomerForStoreDelivery(
  cartType,
  selectedRider,
  tempOrderEdit
) {
  
  return (dispatch) => {
    dispatch(
      slice.actions.updatePosCartForStoreDelivery({
        cartType,
        selectedRider,
        tempOrderEdit,
      })
    );
  };
}



// receipt count
export function updateReceiptCount(cartId, receiptName) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(
        `${backendUrl}/posCart/updateReceiptCount?cartId=${cartId}&receiptName=${receiptName}`,
      );
      dispatch(slice.actions.updateReceiptCountOnCart(response?.data));
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error("error", error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateReceiptCountAddOrder(cartId, receiptName) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(
        `${backendUrl}/posCart/updateReceiptCount?cartId=${cartId}&receiptName=${receiptName}`,
      );
      dispatch(slice.actions.updateReceiptCountOnCart(response?.data));
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.error("error", error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateCartAfterDiscount(res) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.updateCartAfterDiscount(res));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getCartFromOpenOrder(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getCartSuccess(data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      return false;
    }
  };
}

export function updatePosCartTaxOnly(tax, taxObject) {
  return (dispatch) => {
    dispatch(slice.actions.updatePosCartTax({tax,taxObject})
    );
  };
}
